import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {
  Account,
  AccountPermissions,
  AccountCertificate,
} from '@personal-area/global/accounts/models';

export const AccountActions = createActionGroup({
  source: 'Account',
  events: {
    'Get accounts': (userId: number) => ({ userId }),
    'Get accounts success': (accounts: Account[], primaryAccountId: number) => ({ accounts, primaryAccountId }),
    'Get accounts fail': emptyProps(),
    'Get account': props<{ accountId: number }>(),
    'Get account success': props<{ account: Account }>(),
    'Get account fail': emptyProps(),
    'Select account': (accountId: number) => ({ accountId }),
    'Select partner account': emptyProps(),
    'Select exchanger account': emptyProps(),
    'Select first available account': emptyProps(),
    'Select action': (action: AccountPermissions | null) => ({ action }),
    'Select primary account': (accountId: number) => ({ accountId }),
    'Update account': props<{ update: Update<Account> }>(),
    'Save certificate': props<{ id: number; certificate: AccountCertificate; }>(),
    'Remove certificate': props<{ id: number; }>(),
    'Create partner account': emptyProps(),
    'Create partner account success': emptyProps(),
  }
});
